import React from 'react'
import useModal from './modalHook';
import AddVehicle from '../views/admin/vehicles/AddVehicle';

const useVehicle = () => {
     const { ModalComponent, updateModalStates, closeModal } = useModal();
     const VehicleModal = ModalComponent;
     
      const addVehicle = () => {
        updateModalStates({
          show: true,
          size: 'xl',
          children: (
            <AddVehicle
              onProceed={() => {
                closeModal();
              }}
              onClose={closeModal}
            />
          ),
          
          classes: '!p-0 r-[5px]'
        });
      };

  return {
    addVehicle,
    VehicleModal
  }
}

export default useVehicle